import { fetchAuthSession } from "aws-amplify/auth";

function getIdToken() {
  return new Promise((resolve, reject) =>
    fetchAuthSession({ forceRefresh: true })
      .then((session) => {
        resolve(session.tokens.idToken.toString());
      })
      .catch((error) => {
        reject(error);
      }),
  );
}

function getIdTokenPayload() {
  return new Promise((resolve, reject) =>
    fetchAuthSession({ forceRefresh: true })
      .then((session) => {
        resolve(session.tokens.idToken);
      })
      .catch((error) => {
        reject(error);
      }),
  );
}

export { getIdToken, getIdTokenPayload };
